"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import Icon from "../../graphics/Icon/Icon.js";
import Group from "../../layout/Group/Group.js";
import Link from "../../navigation/Link/Link.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Box, Accordion as Accordion$1, rem } from "@mantine/core";
import { forwardRef, useState } from "react";
import '../../../assets/Accordion.css';const root = "_root_zzc59_2";
const item = "_item_zzc59_7";
const control = "_control_zzc59_12";
const controlIcon = "_controlIcon_zzc59_26";
const chevron = "_chevron_zzc59_34";
const iconGroup = "_iconGroup_zzc59_42";
const openIcon = "_openIcon_zzc59_49";
const closedIcon = "_closedIcon_zzc59_50";
const AccordionStyles = {
  root,
  item,
  control,
  controlIcon,
  chevron,
  iconGroup,
  openIcon,
  closedIcon
};
const _Accordion = forwardRef((props, ref) => {
  const {
    items,
    chevronPosition = "right",
    closedIcon: closedIcon2,
    openIcon: openIcon2,
    onChange,
    value,
    loop,
    defaultValue,
    transitionDuration,
    disableChevronRotation: chevronRotation = false,
    ...rest
  } = props;
  const [localValue, setValue] = useState(value);
  const handleChange = (val) => {
    onChange == null ? void 0 : onChange(val);
    setValue(val);
  };
  const chevronComponent = (chevron2, itemValue) => {
    if (chevron2) {
      return /* @__PURE__ */ jsx(Icon, { name: chevron2, size: rem("26px") });
    }
    if (closedIcon2 && openIcon2) {
      return /* @__PURE__ */ jsxs(Group, { className: AccordionStyles.iconGroup, children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: closedIcon2,
            className: AccordionStyles.closedIcon,
            size: rem("26px"),
            mod: { show: itemValue !== localValue }
          }
        ),
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: openIcon2,
            className: AccordionStyles.openIcon,
            size: rem("26px"),
            mod: { show: itemValue === localValue }
          }
        )
      ] });
    }
    return void 0;
  };
  const iconComponent = (icon, iconVariant) => icon && /* @__PURE__ */ jsx(Icon, { radius: "xl", name: icon, variant: iconVariant || "transparent", size: rem("24px") });
  return /* @__PURE__ */ jsx(Box, { ...rest, ref, children: /* @__PURE__ */ jsx(
    Accordion$1,
    {
      chevronPosition,
      classNames: AccordionStyles,
      onChange: handleChange,
      value: localValue,
      defaultValue,
      loop,
      transitionDuration,
      disableChevronRotation: chevronRotation,
      children: items.map(
        ({
          value: itemValue,
          href,
          disabled,
          icon,
          iconVariant,
          chevron: chevron2,
          labelLink,
          label,
          content,
          mod,
          ...itemRest
        }, index) => /* @__PURE__ */ jsxs(
          Accordion$1.Item,
          {
            value: itemValue,
            component: href ? "a" : "div",
            ...{ href },
            mod,
            children: [
              /* @__PURE__ */ jsx(
                Accordion$1.Control,
                {
                  disabled,
                  icon: iconComponent(icon, iconVariant),
                  chevron: chevronComponent(chevron2, itemValue),
                  className: chevronPosition === "left" && icon ? AccordionStyles.controlIcon : AccordionStyles.control,
                  mod: {
                    "data-multiple-icons": !!closedIcon2 && !!openIcon2,
                    "with-link": Boolean(href)
                  },
                  children: /* @__PURE__ */ jsx(Box, { ...itemRest, children: labelLink ? /* @__PURE__ */ jsx(Link, { href: labelLink, className: "", children: label }) : label })
                }
              ),
              content && /* @__PURE__ */ jsx(Accordion$1.Panel, { children: content })
            ]
          },
          `accordion${index}`
        )
      )
    }
  ) });
});
_Accordion.displayName = "Accordion";
const Accordion = sharedHandler(_Accordion);
Accordion.displayName = _Accordion.displayName;
export {
  AccordionStyles as A,
  Accordion as default
};
